import { initContract } from '@ts-rest/core'
import {
	CampaignAPI,
	CampaignCreatePayload,
	CampaignResponse
} from './campaign.contracts'
import { CouponAPI, CouponMasterAPI } from './coupon.contracts'
import { MemberAPI } from './member.contracts'
import { MemberAttributeAPI } from './memberAttribute.contracts'
import { RichMenuAPI } from './richmenu.contracts'
import { RichMenuTabGroupAPI } from './richmenuTabGroup.contracts'
import { RootAPI } from './root.contracts'
import { SettingsAPI } from './settings.contracts'

const c = initContract()

export type { CampaignCreatePayload, CampaignResponse }
export const ContractAPI = c.router(
	{
		campaigns: CampaignAPI,
		coupons: c.router({
			...CouponAPI,
			masters: CouponMasterAPI
		}),
		members: MemberAPI,
		memberAttributes: MemberAttributeAPI,
		richmenus: RichMenuAPI,
		richmenutabgroups: RichMenuTabGroupAPI,
		root: RootAPI,
		settings: SettingsAPI
	},
	{
		pathPrefix: '/api'
	}
)
